var _circle, _rect, _g, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllInsufficientBalance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329 201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.281,
    cy: 100.395,
    r: 76.3416,
    fill: "#9AA0DA",
    fillOpacity: 0.14
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6561_32416",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 5,
    width: 111,
    height: 187
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 107.524,
    y: 16.4222,
    width: 87.909,
    height: 178.926,
    rx: 13.3195,
    transform: "rotate(-8.5433 107.524 16.4222)",
    fill: "#6B748D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6561_32416)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.524,
    y: 16.4222,
    width: 87.909,
    height: 178.926,
    rx: 13.3195,
    transform: "rotate(-8.5433 107.524 16.4222)",
    fill: "url(#paint0_linear_6561_32416)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M113.147 29.9444C112.408 25.0265 112.039 22.5675 112.714 20.5454C113.307 18.7666 114.449 17.2215 115.975 16.1314C117.709 14.8921 120.168 14.5227 125.086 13.7839L180.408 5.47333C185.326 4.73455 187.784 4.36515 189.807 5.04006C191.585 5.63373 193.131 6.77528 194.221 8.30109C195.46 10.0357 195.829 12.4947 196.568 17.4126L218.512 163.487C218.992 166.684 219.232 168.282 218.794 169.597C218.408 170.753 217.666 171.757 216.674 172.466C215.546 173.271 213.948 173.511 210.751 173.992L150.513 183.041C145.595 183.78 143.136 184.149 141.114 183.474C139.335 182.881 137.79 181.739 136.7 180.213C135.46 178.479 135.091 176.02 134.352 171.102L113.147 29.9444Z",
    fill: "url(#paint1_linear_6561_32416)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M111.201 16.9922C111.11 16.386 111.528 15.8207 112.134 15.7296L193.127 3.56258C193.862 3.45219 194.547 3.95839 194.657 4.69319C194.729 5.17081 194.4 5.61617 193.922 5.68792L112.464 17.9249C111.858 18.016 111.292 17.5984 111.201 16.9922Z",
    fill: "#C7C8CC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 15.0955,
    height: 3.10789,
    rx: 1.55395,
    transform: "matrix(0.988904 -0.148557 -0.148557 -0.988904 171.501 185.276)",
    fill: "url(#paint2_linear_6561_32416)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116.877,
    y: 20.4049,
    width: 73.7015,
    height: 145.849,
    rx: 7.10376,
    transform: "rotate(-8.5433 116.877 20.4049)",
    fill: "#231C45"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 107.524,
    y: 16.4222,
    width: 87.909,
    height: 178.926,
    rx: 13.3195,
    transform: "rotate(-8.5433 107.524 16.4222)",
    fill: "url(#paint3_linear_6561_32416)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.216 80.6317C144.216 80.6317 145.792 79.9565 149.085 79.4619C152.377 78.9672 153.952 79.1693 153.952 79.1693",
    stroke: "#BCD4FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.097 76.4424C172.097 76.4424 173.672 75.7672 176.965 75.2725C180.258 74.7778 181.832 74.9799 181.832 74.9799",
    stroke: "#BCD4FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.826 100.246C138.826 100.246 139.702 98.2518 143.303 97.7132C145.12 97.4414 147.933 99.5191 150.339 98.8822C152.486 98.3135 155.597 96.5832 158.104 96.0508C160.49 95.5441 163.967 96.8357 166.563 96.446C169.427 96.0158 172.005 93.2394 174.657 93.0049C177.163 92.7832 178.758 94.0189 180.921 93.9246C183.339 93.8192 185.908 91.3508 187.663 91.0517C191.05 90.4746 192.609 91.9652 192.609 91.9652",
    stroke: "#BCD4FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.576 56.5978L177.742 45.5681",
    stroke: "#8D99FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.358 54.3884L183.705 45.853",
    stroke: "#8D99FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.279 55.0427L189.545 46.3023",
    stroke: "#8D99FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.072 16.241C217.589 14.1476 222.115 15.2634 224.18 18.7331C226.245 22.2028 225.067 26.7125 221.55 28.8059C216.195 31.9923 209.592 31.319 206.474 30.7402C205.451 30.5502 204.853 29.5572 205.167 28.5652C206.118 25.5612 208.632 19.4785 214.072 16.241Z",
    fill: "url(#paint4_linear_6561_32416)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.299 34.5317C237.344 35.1623 240.118 38.9076 239.496 42.8971C238.874 46.8865 235.091 49.6093 231.047 48.9787C224.89 48.0187 220.233 43.289 218.201 40.8548C217.534 40.0561 217.706 38.9098 218.581 38.3461C221.23 36.6389 227.044 33.5563 233.299 34.5317Z",
    fill: "url(#paint5_linear_6561_32416)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6561_32416",
    x1: 114.517,
    y1: 50.9421,
    x2: 260.921,
    y2: 103.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#535678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6561_32416",
    x1: 118.2,
    y1: 23.2365,
    x2: 213.245,
    y2: 166.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8890A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C758E",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6561_32416",
    x1: 7.54774,
    y1: 0,
    x2: 7.54774,
    y2: 3.10789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6561_32416",
    x1: 146.3,
    y1: 21.457,
    x2: 145.801,
    y2: 90.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#47C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47C8E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6561_32416",
    x1: 224.07,
    y1: 31.8093,
    x2: 204.001,
    y2: 21.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34DCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6561_32416",
    x1: 231.073,
    y1: 52.8994,
    x2: 222.161,
    y2: 32.1933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34DCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F5F6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllInsufficientBalance);
export default __webpack_public_path__ + "static/media/ill-insufficient-balance.aeb1b05d253975c64b8c5a02f5423ccc.svg";
export { ForwardRef as ReactComponent };